<template>
  <div class="Contact" ref="Contact">
    <Head :isWhite="isWhiteLogo" :isMenu="isMenu" @isMenuShow="isMenuShow" />
    <Amap />
    <div class="container">
      <div class="Tabs">
        <ul>
          <li v-for="(item, index) in Tabs" :key="index" :class="isTabsActive == index ? 'isTabsActive' : ''" @click="isTabsActive = index">{{ item }}</li>
        </ul>
      </div>
      <div class="content">
        <div class="item">
          <p>西索教育科技集团</p>
          <ul>
            <li>
              <div class="title">公司地址</div>
              <span>{{ isTabsActive == 0 ? '湖北省武汉市洪山区珞喻路10号武汉百脑汇资讯广场1栋3405~3410' : '616-4798 Yonge Street, North York, ON M2N 0G3（Canada）' }}</span>
            </li>
            <li>
              <div class="title">联系电话</div>
              <span>{{ isTabsActive == 0 ? '400-686-9191' : '416-225-2666 加拿大（CA）' }}</span>
            </li>
            <li>
              <div class="title">人才联络</div>
              <div class="box">
                <p>
                  <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/icon1.png" width="25px" />
                  <span>hr@csoedu.com</span>
                </p>
                <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/ewm1.png" width="100px" />
              </div>
            </li>
            <li>
              <div class="title">投资合作</div>
              <div class="box">
                <p>
                  <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/icon1.png" width="25px" />
                  <span>xiajun@csoedu.com</span>
                </p>
                <p>
                  <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/icon2.png" width="29px" />
                  <span>+86 159 2748 1700</span>
                </p>
                <p>
                  <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/icon3.png" width="32px" />
                  <span>xiajun8681</span>
                </p>
              </div>
            </li>
            <li>
              <div class="title">媒体联络</div>
              <div class="box">
                <p>
                  <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/icon1.png" width="25px" />
                  <span>yuanyuan@csoedu.com</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div class="item">
          <ul>
            <li>
              <div class="title">集团官方公众号</div>
              <div class="box">
                <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/ewm2.png" width="200px" />
              </div>
              <p>旗下品牌公众号</p>
              <ul>
                <li>
                  <div class="Ewm"><img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/ewm3.png" width="100%" /></div>
                  <p>cso</p>
                </li>
                <li>
                  <div class="Ewm"><img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/ewm4.png" width="100%" /></div>
                  <p>uai</p>
                </li>
                <li>
                  <div class="Ewm"><img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/ewm5.png" width="100%" /></div>
                  <p>西索商学院</p>
                </li>
                <li>
                  <div class="Ewm"><img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/ewm6.png" width="100%" /></div>
                  <p>TA</p>
                </li>
                <!--<li>
                  <div class="Ewm"><img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Contact/ewm3.png" width="100%" /></div>
                  <p>加拿大文理中学</p>
                </li>-->
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Foot @isBackTop="isBackTop" />
  </div>
</template>
<script>
import Head from '@/components/Head'
import Foot from '@/components/Foot'
import Amap from '@/components/Amap'
export default {
  components: {
    Head,
    Foot,
    Amap
  },
  data() {
    return {
      isWhiteLogo: false,
      isMenu: false,
      isTabsActive: 0,
      Tabs: ['国内联系方式', '北美联系方式']
    }
  },
  mounted() {},
  methods: {
    isMenuShow(e) {
      this.isMenu = e
    },
    isBackTop() {
      let _this = this
      let ScrollTime = setInterval(() => {
        if (_this.$refs.Contact.scrollTop > 0) {
          _this.$refs.Contact.scrollTop = _this.$refs.Contact.scrollTop - 50
        }
        if (_this.$refs.Contact.scrollTop == 0) {
          clearInterval(ScrollTime)
        }
      }, this.$refs.Contact.scrollTop / 1000000)
    }
  }
}
</script>
<style lang="less" scoped>
.Contact {
  width: 100%;
  height: 100%;
  min-width: 1440px;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .container {
    width: 1400px;
    overflow: hidden;
    margin: 0 auto 40px auto;
    .Tabs {
      width: 100%;
      height: 60px;
      overflow: hidden;
      background: #ffffff;
      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        li {
          width: 700px;
          height: 60px;
          overflow: hidden;
          color: #111111;
          font-size: 24px;
          font-family: 'Bold';
          line-height: 60px;
          text-align: center;
          transition: all 0.2s;
          cursor: pointer;
          &.isTabsActive {
            background: #2d64fa;
            color: #ffffff;
          }
        }
      }
    }
    .content {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      margin-top: 90px;
      .item {
        width: 660px;
        overflow: hidden;
        > p {
          font-size: 20px;
          line-height: 1;
          font-family: 'Bold';
          color: #2d64fa;
        }
        > ul {
          margin-top: 50px;
          > li {
            width: 100%;
            overflow: hidden;
            margin-top: 25px;
            .title {
              width: 100%;
              overflow: hidden;
              font-size: 16px;
              font-family: 'Bold';
              padding-bottom: 12px;
              border-bottom: 2px dotted #999999;
            }
            > span {
              display: inline-block;
              font-size: 14px;
              margin-top: 25px;
            }
            &:nth-child(3) {
              .box {
                p {
                  height: 17px;
                }
              }
            }
            .box {
              display: flex;
              justify-content: space-between;
              margin-top: 25px;
              p {
                display: flex;
                align-items: center;
                img {
                  margin-right: 12px;
                }
              }
            }
          }
        }
        &:last-child {
          > ul {
            margin-top: 0;
            > li {
              margin-top: 0;
              > p {
                font-size: 20px;
                line-height: 1;
                font-family: 'Bold';
                color: #2d64fa;
                margin: 60px 0;
              }
              ul {
                width: 100%;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: space-between;
                li {
                  width: max-content;
                  overflow: hidden;
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  .Ewm {
                    width: 100px;
                    height: 100px;
                    overflow: hidden;
                    background: #70a1c2;
                  }
                  p {
                    font-size: 16px;
                    margin-top: 10px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
